import React from 'react';
import { observer } from 'mobx-react-lite';

import { Flex, Text, BaseLink } from 'src/kit';
import { LogoBig } from 'src/components';
import { useStore } from '@src/models';

export const StandaloneFooter = observer(() => {
  const {
    companyStore: { company }
  } = useStore();
  return (
    <Flex
      px={10}
      flexDirection={{ xs: 'column', md: 'row' }}
      alignItems="center"
      justifyContent={{ xs: 'space-around', md: 'space-between' }}
      minHeight={60}
      bg={'black' || company?.color}
      color="white"
    >
      <BaseLink href={company?.website} fontWeight="light" textStyle="underline">
        {company?.name} website
      </BaseLink>
      <Flex alignItems="center">
        <Text mr={5} fontWeight="light">
          Powered by
        </Text>
        <LogoBig height={25} />
      </Flex>
    </Flex>
  );
});
